import { render, staticRenderFns } from "./PaymentInvoicesMenu.vue?vue&type=template&id=21726c20&"
import script from "./PaymentInvoicesMenu.vue?vue&type=script&lang=js&"
export * from "./PaymentInvoicesMenu.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInvoicesMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
